module.exports = __webpack_public_path__ + "static/img/bg-en.6b3a8b95.png";